import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from "@material-ui/core";
import { addRegisteredSectionLayout } from "../../sectionLayoutDescriptions";
import { FormattedMessage } from "react-intl";
import { Formik } from "formik";
import * as resources from "@ploy-lib/rest-resources";
import { ResourceDataProvider, CalcRulesDataProvider } from "./TableDataProvider";
import { getFieldName } from "@ploy-lib/core";
import { FormTable } from "./FormTable";
addRegisteredSectionLayout({
    name: "FormTableSection",
    displayName: "FormTableSection",
    settings: {
        editableOptions: {
            tableDataType: true,
            fullWidth: true
        }
    }
});
const FormTableSection = (props) => {
    const { dataSource, tableType = "", tableColumns = [], disabled } = props;
    const resource = dataSource?.isResource
        ? resources[dataSource.sourceName]
        : null;
    if (dataSource?.isResource) {
        if (resource && dataSource.entityId) {
            return (_jsx(ResourceDataProvider, { resource: resource, resourceId: dataSource.entityId, tableColumns: tableColumns, tableColor: props.tableColor, tableSchema: props.tableSchema, disabled: disabled, children: providerProps => (_jsx(Formik, { initialValues: {
                        rows: providerProps.rows
                    }, onSubmit: () => { }, enableReinitialize: true, children: _jsx(FormTable, { ...props, ...providerProps }) })) }));
        }
    }
    else {
        if (tableType) {
            return (_jsx(CalcRulesDataProvider, { tableType: tableType, namespace: dataSource?.namespace, name: getFieldName({
                    name: tableType,
                    namespace: dataSource?.namespace
                }), tableColumns: tableColumns, tableColor: props.tableColor, tableSchema: props.tableSchema, disabled: disabled, children: providerProps => _jsx(FormTable, { ...props, ...providerProps }) }));
        }
    }
    return (_jsx(Typography, { children: _jsx(FormattedMessage, { id: "tableSection.noProvider", defaultMessage: "Fant ikke datagrunnlag for tabellen" }) }));
};
FormTableSection.displayName = "DployFormTableSection";
export { FormTableSection };
//# sourceMappingURL=FormTableSection.js.map